import { IonRouterLink } from '@ionic/react'
import { format } from 'date-fns'

type Props = {
  createdAt: string
  href: string
  previewImage?: string | null
  previewText?: string | null
  status?: string | null
  title: string
  type: string
}

function GridItem({
  createdAt,
  href,
  previewImage,
  previewText,
  status,
  title,
  type,
}: Props) {
  return (
    <IonRouterLink routerLink={href} className="block h-full">
      <div className="flex h-full flex-col overflow-hidden rounded-lg bg-white shadow-sm transition-shadow duration-200 hover:shadow-md">
        <div
          className="relative flex-shrink-0 bg-gray-100"
          style={{ paddingBottom: '133.33%' }}
        >
          <div className="absolute inset-0">
            {previewImage ? (
              <img
                src={previewImage}
                alt={title}
                className="h-full w-full object-cover"
              />
            ) : previewText ? (
              <div className="flex h-full w-full items-center justify-center bg-gray-50 p-4">
                <p className="line-clamp-6 text-center text-sm text-gray-600">
                  {previewText}
                </p>
              </div>
            ) : (
              <div className="flex h-full w-full items-center justify-center bg-gray-50 p-6">
                <p className="text-center text-xl font-medium text-gray-800">
                  {title}
                </p>
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-grow flex-col p-4">
          <h3 className="mb-1 truncate font-medium text-gray-900">{title}</h3>
          <div className="mt-auto flex flex-col gap-2">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-500">
                Created at {format(new Date(createdAt), 'MMM d, yyyy')}
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="rounded-full bg-gray-100 px-2 py-1 text-xs capitalize text-gray-600">
                {type}
              </span>
              {status ? (
                <span className="rounded-full bg-gray-100 px-2 py-1 text-xs capitalize text-gray-600">
                  Status: {status}
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </IonRouterLink>
  )
}

export { GridItem }
